<template>
  <div>
    <h2>
      <v-icon color="accent">{{icono}}</v-icon>
      {{titulo}}
    </h2>
    <br>
    <v-form v-model="valid" ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm10 md10 lg10 class="pr-2">
        <v-layout row wrap>
          <v-flex xs2 sm2 md2 lg2>
            <strong class="mr-1">ID</strong>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6>
            <strong>{{ registro.id}}</strong>
          </v-flex>
        </v-layout>
        <v-text-field
          label="Nombre"
          v-model="registro.nombre"
          :rules="nameRules"
          required
        ></v-text-field>
        <v-text-field
          label="Modelo GPS"
          v-model="registro.modeloGPS"
          :rules="nameRules"
          required
        ></v-text-field>
        <v-text-field
          label="Comando"
          v-model="registro.comandoEnviado"
          :rules="nameRules"
          required
        ></v-text-field>
        <v-text-field
          label="Descripción"
          v-model="registro.comandoDescripcion"
          required
        ></v-text-field>
        <v-checkbox
          label="Enviado"
          v-model="registro.enviado"
          disabled
        ></v-checkbox>

        <v-layout row wrap>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaCreacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Actualización</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaActualizacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Usuario Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.usuarioCreacion" class="info--text">{{ registro.usuarioCreacion.username}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Grupo</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.group" class="info--text">{{ registro.group.name}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Propietario</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.propietario" class="info--text">{{ registro.propietario.username}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm2 md2 lg2>
        <v-btn
          block
          @click="submit"
          :disabled="!valid"
          color="success"
        >
          <v-icon v-show="accion == 1" small left>fas fa-plus</v-icon>
          <v-icon v-show="accion == 2" small left>fas fa-edit</v-icon>
          <span v-show="accion == 1">Agregar</span>
          <span v-show="accion == 2">Actualizar</span>
        </v-btn>
        <v-btn @click="dialogoEliminar" block color="error" v-show="accion == 2">
          <v-icon left small>fas fa-trash-alt</v-icon>
          Eliminar
        </v-btn>
        <v-btn @click="cancelar" block >
          <v-icon left small>fas fa-chevron-left</v-icon>
          cancelar
        </v-btn>
        <Ownership v-if="accion == 2" :objeto="registro"></Ownership>
      </v-flex>
    </v-layout>
    </v-form>

    <v-dialog v-model="dialog3" max-width="400px">
      <v-card>
        <v-card-title>
          <span>Confirme que desea eliminar el registro</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" @click.stop="eliminar()">
            <v-icon left small>fas fa-trash-alt</v-icon>
            Aceptar
          </v-btn>
          <v-btn flat @click.stop="dialog3=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br>
    <v-divider></v-divider>
    <br>
    <v-tabs
      v-model="tabActivo"
      color="cyan"
      dark
      slider-color="yellow"
      v-if="accion == 2 && registro.id"
    >
      <v-tab v-for="t in tabs" :key="t.id" ripple>
        {{ t.titulo }}
      </v-tab>
      <v-tab-item :key="1">
        Relación 1
      </v-tab-item>
      <v-tab-item :key="2">
        Relación 2
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import Comandos from '../../services/comandos'
import Ownership from '../shared/OwnershipComponent'

export default {
  name: 'ComandoDetalle',
  data () {
    return {
      titulo: 'Comando Detalle',
      icono: 'fas fa-terminal',
      accion: null,
      e1: true,
      dialog3: false,
      registro: { comandoEnviado: ''},
      valid: true,
      tabActivo: null,
      nameRules: [
        v => !!v || 'Ingrese un nombre de Comando válido',
        v => (v && v.length <= 45) || 'El nombre debe ser menor a 45 caracteres'
      ],
      mensaje: false,
      tabs: [
        {id: 1, titulo: 'Vehiculos'}
      ],
      filtroVehiculos: null
    }
  },
  components: {
    Ownership
  },
  provide: function () {
    return {
      servicio: Comandos
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        if (this.accion === 1) {
          this.registro = await Comandos.save(this.registro)
          this.accion = 2
          this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'success'})
        } else {
          this.registro = await Comandos.update(this.registro)
          this.$emit('show-message', {msg: 'Registro Actualizado', tipo: 'success'})
          this.mensaje = true
        }
      }
    },
    async eliminar() {
      await Comandos.delete(this.registro.id)
      this.dialog3 = false
      this.$emit('show-message', 'Registro Eliminado')
      setTimeout(this.cancelar, 800)
    },
    cancelar () {
      this.$router.push('/comandos')
    },
    dialogoEliminar() {
      this.dialog3 = true
    }
  },
  beforeMount: async function() {
    if (this.$route.params.id === '0') {
      this.accion = 1 //Agregar
    } else {
      this.accion = 2 //Actualizar
      this.registro = await Comandos.get(this.$route.params.id, { populate: 'usuarioCreacion,propietario'})
      if (!this.registro) {
        this.cancelar()
      }
      this.filtroVehiculos = { registro: this.registro.id }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/comandos/ComandoDetalle.vue